var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c(
        "div",
        [
          _c(
            "el-row",
            [
              _c("divider", {
                attrs: { label: "Confirmar publicação no Diário Oficial" }
              })
            ],
            1
          ),
          _c("el-row", [
            _vm.bytes
              ? _c(
                  "div",
                  { attrs: { id: "pdf" } },
                  [_c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })],
                  1
                )
              : _vm._e()
          ]),
          _c(
            "el-row",
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Publicação no diário oficial"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          staticClass: "upload-margin",
                          attrs: {
                            label: "Upload da Publicação no Diário Oficial",
                            required: true
                          }
                        }),
                        _c("app-upload-area", {
                          attrs: {
                            id: "diarioOficial",
                            target: _vm.urlUpload,
                            fileType: _vm.validExtensions,
                            onSuccess: _vm.onSuccess,
                            documento: _vm.despacho.documento,
                            errors: errors
                          },
                          on: {
                            download: _vm.download,
                            removerDocumento: _vm.removerDocumento
                          },
                          model: {
                            value: _vm.despacho.documento,
                            callback: function($$v) {
                              _vm.$set(_vm.despacho, "documento", $$v)
                            },
                            expression: "despacho.documento"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-row", [
            _c(
              "div",
              { staticClass: "container" },
              [
                _vm.radiosAcoes.length &&
                _vm.processo.status !== "AGUARDANDO_PUBLICACAO_DIARIO_OFICIAL"
                  ? _c("app-radios-tramitacao", {
                      attrs: {
                        radios: _vm.radiosAcoes,
                        isDecisao: true,
                        radioInicial: _vm.radioInicial
                      },
                      on: { changeRadio: _vm.changeRadio }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("el-row", [
            _c(
              "div",
              { attrs: { id: "btn" } },
              [
                _c("app-buttons-cadastro", {
                  attrs: {
                    showButtonDownload: true,
                    showButtonCancelar: false,
                    isUltimoPasso: true,
                    finalizarLabel: "Finalizar",
                    downloadLabel: "Download PDF"
                  },
                  on: {
                    download: _vm.download,
                    voltar: _vm.goToListagem,
                    finalizar: _vm.finalizar
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6293302c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6293302c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gp/components/diarioOficial/InformarPublicacao.vue
// module id = null
// module chunks = 